// Nam Fruits — Header custom element
// Handles language dropdown + mobile menu toggle + outside-click dismiss
// Lifecycle-safe: re-binds on section reload in theme editor.

class NFHeader extends HTMLElement {
  constructor() {
    super();
    this._outsideClickHandler = this._onOutsideClick.bind(this);
  }

  connectedCallback() {
    this.langToggle = this.querySelector('.nf-header__lang-toggle');
    this.langMenu = this.querySelector('#nf-lang-menu');
    this.mobileToggle = this.querySelector('.nf-header__menu-toggle');

    if (this.langToggle && this.langMenu) {
      this.langToggle.addEventListener('click', this._onLangToggle.bind(this));
      document.addEventListener('click', this._outsideClickHandler);
    }

    if (this.mobileToggle) {
      this.mobileToggle.addEventListener('click', this._onMobileToggle.bind(this));
    }

    // Dropdown menus (30/10/2026): click/tap toggles, outside click + Escape close; desktop also opens on hover (CSS)
    this.subTriggers = Array.from(this.querySelectorAll('.nf-header__menu-trigger'));
    if (this.subTriggers.length) {
      this.subTriggers.forEach((btn) => btn.addEventListener('click', () => this._toggleSub(btn)));
      this._subOutsideHandler = (e) => {
        if (!e.target.closest('.nf-header__menu-item--has-sub')) this._closeSubs();
      };
      this._subKeyHandler = (e) => {
        if (e.key === 'Escape') this._closeSubs();
      };
      document.addEventListener('click', this._subOutsideHandler);
      document.addEventListener('keydown', this._subKeyHandler);
    }
  }

  _toggleSub(btn) {
    const item = btn.closest('.nf-header__menu-item--has-sub');
    const open = !item.classList.contains('is-open');
    this._closeSubs();
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', String(open));
  }

  _closeSubs() {
    (this.subTriggers || []).forEach((btn) => {
      btn.closest('.nf-header__menu-item--has-sub').classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._outsideClickHandler);
    if (this._subOutsideHandler) document.removeEventListener('click', this._subOutsideHandler);
    if (this._subKeyHandler) document.removeEventListener('keydown', this._subKeyHandler);
    if (document.body) document.body.classList.remove('nf-no-scroll');
    this.classList.remove('nf-header--mobile-open');
  }

  _onLangToggle() {
    const open = this.langToggle.getAttribute('aria-expanded') === 'true';
    this.langToggle.setAttribute('aria-expanded', String(!open));
    this.langMenu.hidden = open;
  }

  _onOutsideClick(e) {
    if (!this.langToggle || !this.langMenu) return;
    if (this.langToggle.contains(e.target)) return;
    if (this.langMenu.contains(e.target)) return;
    this.langToggle.setAttribute('aria-expanded', 'false');
    this.langMenu.hidden = true;
  }

  _onMobileToggle() {
    const open = this.mobileToggle.getAttribute('aria-expanded') === 'true';
    this.mobileToggle.setAttribute('aria-expanded', String(!open));
    this.classList.toggle('nf-header--mobile-open', !open);
    document.body.classList.toggle('nf-no-scroll', !open);
  }
}

if (!customElements.get('nf-header')) {
  customElements.define('nf-header', NFHeader);
}
